import { render, staticRenderFns } from "./MyPublish.vue?vue&type=template&id=4462c500&scoped=true&"
import script from "./MyPublish.vue?vue&type=script&lang=js&"
export * from "./MyPublish.vue?vue&type=script&lang=js&"
import style0 from "./MyPublish.vue?vue&type=style&index=0&id=4462c500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4462c500",
  null
  
)

export default component.exports